import React from "react";
import ResponsiveAppBar from "./ResponsiveAppBar";
import {
  Box,
  Typography,
  Container,
  createTheme,
  ThemeProvider,
  Button,
} from "@common-ui/ui";
import { ArrowBack } from "@mui/icons-material";
import { MenuAppBar, MenuAppBarWithBreadcrumbs } from "./AppBar";

const darThemeAppBar = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1920,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          height: "37px",
          fontFamily: "Roboto",
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiButtonBase: {
      defaultProps: {},
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          backgroundColor: "rgba(0, 0, 0, 0.02)",
        },
      },
    },
  },
  palette: {
    mode: "dark",
    // primary: {
    //   main: "#006faa",
    // },
    secondary: {
      main: "#FFC20E",
    },
    success: {
      main: "#64A687",
    },
    info: {
      main: "#006FAA",
    },
    warning: {
      main: "#ff9800",
    },
    error: {
      main: "#c62828",
    },
  },
  shape: {
    borderRadius: 4,
  },
  shadows: [
    "none",
    "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)",
    "0px 1px 2px rgba(100, 116, 139, 0.12)",
    "0px 1px 4px rgba(100, 116, 139, 0.12)",
    "0px 1px 5px rgba(100, 116, 139, 0.12)",
    "0px 1px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 6px rgba(100, 116, 139, 0.12)",
    "0px 3px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)",
    "0px 5px 12px rgba(100, 116, 139, 0.12)",
    "0px 5px 14px rgba(100, 116, 139, 0.12)",
    "0px 5px 15px rgba(100, 116, 139, 0.12)",
    "0px 6px 15px rgba(100, 116, 139, 0.12)",
    "0px 7px 15px rgba(100, 116, 139, 0.12)",
    "0px 8px 15px rgba(100, 116, 139, 0.12)",
    "0px 9px 15px rgba(100, 116, 139, 0.12)",
    "0px 10px 15px rgba(100, 116, 139, 0.12)",
    "0px 12px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 13px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 14px 24px -8px rgba(100, 116, 139, 0.25)",
    "0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
  ],
  overrides: {
    MuiAppBar: {
      colorInherit: {
        backgroundColor: "#222222",
        color: "#fff",
      },
    },
  },
  props: {
    MuiAppBar: {
      color: "inherit",
    },
  },
  typography: {
    h1: {
      fontFamily: "Roboto",
      fontSize: "3.8rem",
      fontWeight: 200,
    },
    h2: {
      fontFamily: "Roboto",
      fontSize: "2.5rem",
      fontWeight: 400,
    },
    h3: {
      fontFamily: "Roboto",
      fontSize: "1.875rem",
      fontWeight: 500,
    },
    h4: {
      fontFamily: "Roboto",
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontFamily: "Roboto",
      fontSize: "1.1rem",
      fontWeight: 600,
    },
    h6: {
      fontFamily: "Open Sans",
      fontSize: "1.1rem",
      fontWeight: 700,
    },
    fontFamily: "Open Sans",
    subtitle1: {
      fontWeight: 700,
      fontSize: "0.8rem",
      lineHeight: 1.55,
    },
    button: {
      fontWeight: 600,
      fontFamily: "Roboto Nato",
      lineHeight: 2,
      strokeWidth: 2,
      textTransform: "capitalize",
      borderRadius: 30,
    },
    overline: {
      lineHeight: 2.52,
      fontSize: "0.7rem",
      fontWeight: 600,
    },
    subtitle2: {
      fontWeight: 800,
    },
    fontSize: 14,
    body1: {
      fontSize: "0.9rem",
    },
    body2: {
      fontSize: "0.8rem",
    },
  },
});
const Header = ({
  xl,
  action,
  history,
  name = "",
  appName = "Fluke Works",
  home,
  menuBar,
  breadcrumbs,
  noMargin,
  headerBackgroundImage = "https://d3ab4pgc1q9ec1.cloudfront.net/client/assets-bg.png",
}) => {
  const handleBackClick = () => {
    if (history) {
      if (
        history.location?.state?.from &&
        history.location?.state?.from === "/create-user-profile"
      ) {
        history.go(-3);
      } else {
        history.goBack();
      }
    }
  };

  return (
    <>
      <ThemeProvider theme={darThemeAppBar}>
        <ResponsiveAppBar appName={appName} history={history} />
      </ThemeProvider>
      {!home && menuBar && <MenuAppBar name={name} action={action} />}
      {breadcrumbs && (
        <MenuAppBarWithBreadcrumbs noMargin={noMargin} items={breadcrumbs} />
      )}
      {home && (
        <Box
          sx={{
            height: 110,
            position: "relative",
          }}
          style={{
            display: "flex",
            alignItems: "center",
            // marginTop: 50,
            marginBottom: noMargin ? 0 : 8,
            backgroundColor:
              window?.location.pathname !== "/" ? "#ebebeb" : "transparent",
          }}
        >
          <Container maxWidth={xl ? "xl" : "md"} component="main">
            {history?.location["length"] > 2 ||
            history?.location["pathname"] !== "/" ? (
              <Button
                startIcon={<ArrowBack color="grey" />}
                onClick={handleBackClick}
                component="a"
                style={{ color: "grey" }}
              >
                Back
              </Button>
            ) : (
              ""
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h3"
                component="h2"
                color="text.primary"
                fontSize="32px"
                fontWeight="300"
                style={{ color: "#333333" }}
              >
                {name}
              </Typography>
              {action ? <div>{action}</div> : ""}
            </div>
          </Container>
        </Box>
      )}
    </>
  );
};

export { Header };
